import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  Divider,
  Stack,
  Typography,
  Avatar,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ImageList,
  ImageListItem
} from '@mui/material';
import Label from 'src/components/Label';
import ImgsViewer from 'react-images-viewer';
import palette from 'src/theme/palette';

const OrderDetailModal = ({ productDetails, handleClose }) => {
  const [imagesMultiple, setimagesMultiple] = useState([]);
  const [fullImage, setfullImage] = useState(false);
  const [mainLength, setmainLength] = useState(0);

  function imagesArray() {
    setmainLength(imagesMultiple.length);
    imagesMultiple.length = 0;
    if (productDetails?.refund?.images?.length > 0) {
      productDetails?.refund?.images?.map((item, index) => {
        setimagesMultiple((imagesMultiple) => [
          ...imagesMultiple,
          {
            src: item?.uri
          }
        ]);
      });
    }
  }

  const [index, setindex] = useState(0);

  function gotoPrevious() {
    if (index >= 0 && index <= mainLength) {
      setindex(index - 1);
    }
  }
  function gotoNext() {
    if (index >= 0 && index < mainLength) {
      setindex(index + 1);
    }
  }

  function settingFullImage(index) {
    imagesArray();
    setindex(index);
    setfullImage(true);
  }

  useEffect(() => {
    imagesArray();
  }, []);

  const getStatusColor = (status) => {
    console.log(status);
    switch (status.toLowerCase()) {
      case 'placed':
        return 'secondary';
      case 'shipped':
        return 'info';
      case 'delivered':
        return 'success';
      case 'completed':
        return 'success';
      case 'refunded':
        return 'warning';
      case 'cancelled':
        return 'error';
      default:
        return 'primary';
    }
  };

  return (
    <Box>
      <Typography variant="h5" textAlign={'center'} mb={2}>
        Details
      </Typography>
      <Stack>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Order NO:{' '}
          </Typography>
          <Typography variant="body2" ml={1}>
            {productDetails?.order_no || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Shipping Address:{' '}
          </Typography>
          <Typography variant="body2" ml={1}>
            {productDetails?.shipping_address?.location || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Billing Address:{' '}
          </Typography>

          <Typography variant="body2" ml={1}>
            {productDetails?.delivery_address?.location || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Payment Method:{' '}
          </Typography>

          <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
            {productDetails?.payment_method || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Status:
          </Typography>
          <Label
            style={{ height: 30, paddingLeft: 30, paddingRight: 30, width: 100, marginLeft: 10 }}
            variant="ghost"
            color={getStatusColor(productDetails?.status)}
          >
            <Typography variant="body2" style={{ textTransform: 'capitalize' }}>
              {productDetails?.status}
            </Typography>
          </Label>
        </Box>
        {productDetails?.status.toLowerCase() === 'cancelled' && (
          <>
            <Box style={{ display: 'flex' }}>
              <Typography variant="body2" fontWeight={'bold'}>
                Reason:{' '}
              </Typography>

              <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
                {productDetails?.cancellation_reason || ' N/A'}
              </Typography>
            </Box>
            <Box style={{ display: 'flex' }}>
              <Typography variant="body2" fontWeight={'bold'}>
                Description:{' '}
              </Typography>

              <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
                {productDetails?.cancellation_description || ' N/A'}
              </Typography>
            </Box>
            <Box style={{ display: 'flex' }}>
              <Typography variant="body2" fontWeight={'bold'}>
                Cancelled By:{' '}
              </Typography>

              <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
                {productDetails?.canceled_by || ' N/A'}
              </Typography>
            </Box>
          </>
        )}
        {productDetails?.status.toLowerCase() === 'refunded' && productDetails?.refund && (
          <>
            <Box style={{ display: 'flex' }}>
              <Typography variant="body2" fontWeight={'bold'}>
                Reason:{' '}
              </Typography>

              <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
                {productDetails?.refund?.reason || ' N/A'}
              </Typography>
            </Box>
            <Box style={{ display: 'flex' }}>
              <Typography variant="body2" fontWeight={'bold'}>
                Refunded Amount:{' '}
              </Typography>

              <Typography variant="body2" ml={1} style={{ textTransform: 'capitalize' }}>
                {productDetails?.refund?.amount || ' N/A'}
              </Typography>
            </Box>
            <Box style={{ display: 'flex' }}>
              <Typography
                display={'flex'}
                flexWrap={'wrap'}
                variant="body2"
                style={{ textTransform: 'capitalize', flexDirection: 'row' }}
              >
                <Typography variant="body2" fontWeight={'bold'} minWidth={110}>
                  Admin Remarks:{' '}
                </Typography>
                {productDetails?.refund?.admin_reason || ' N/A'}
              </Typography>
            </Box>
            {/* IMAGE SLIDER WHOLE SCREEN */}
            <ImgsViewer
              imgs={imagesMultiple}
              currImg={index}
              onClickPrev={gotoPrevious}
              onClickNext={gotoNext}
              isOpen={fullImage}
              onClose={() => setfullImage(false)}
            />
            {/* IMAGES ARRAY */}
            {productDetails?.refund?.images?.length > 0 && (
              <>
                <Box
                  pb={1}
                  width="100%"
                  style={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography variant="body2" fontWeight={'bold'}>
                    Evidence:
                  </Typography>
                  <Box my={1}>
                    <ImageList
                      sx={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap'
                      }}
                      cols={5}
                      rowHeight={100}
                      className="justify"
                    >
                      {productDetails?.refund?.images.map((item, index) => (
                        <ImageListItem
                          style={{
                            borderRadius: 15,
                            overflow: 'hidden',
                            border: '2px solid',
                            borderColor: palette.primary.main,
                            backgroundColor: 'silver'
                          }}
                          onClick={() => settingFullImage(index)}
                          key={item?.index}
                        >
                          <img
                            className="image_Width"
                            style={{ width: 90 }}
                            src={item?.uri}
                            alt={'Product Image'}
                            loading="lazy"
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </Box>
                </Box>
              </>
            )}
          </>
        )}
      </Stack>

      <Card style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={'bold'}>
                  Name
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Price (LKR)
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Quantity
                </Typography>
              </TableCell> */}

              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Sub Total
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {productDetails?.order_details?.map((item) => ( */}
            <>
              {console.log('item of orders', productDetails)}
              <TableRow key={productDetails?.order_details[0].code}>
                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar
                      alt={productDetails?.order_details[0]?.name}
                      src={productDetails?.order_details[0]?.product?.media?.uri}
                      style={{ width: 40, height: 40, borderRadius: 20 }}
                    />
                    <div className="one-line-ellipsis">
                      <Typography variant="body2" color="black">
                        {productDetails?.order_details[0]?.product?.name || 'N/A'}
                      </Typography>
                      <Typography variant="caption" color="black">
                        {productDetails?.order_details[0]?.product?.code || 'N/A'}
                      </Typography>
                    </div>
                  </Stack>
                </TableCell>

                <TableCell>
                  <Typography variant="caption">
                    {productDetails?.order_details[0]?.product?.price
                      ? productDetails?.order_details[0]?.product?.price
                      : 'N/A'}
                  </Typography>
                </TableCell>
                {/* <TableCell>
                    <Typography variant="caption">{item?.product?.quantity || 'N/A'}</Typography>
                  </TableCell> */}
                {/* <TableCell>
                <Typography variant="caption">{item?.discount || 'N/A'}</Typography>
              </TableCell> */}
                <TableCell>
                  <Typography variant="caption">{productDetails?.over_all_sum?.total}</Typography>
                </TableCell>
              </TableRow>
            </>
            {/* ))} */}
          </TableBody>
        </Table>
      </Card>
      {productDetails?.discount && (
        <>
          <Typography mt={2} style={{ flex: 1 }} variant="h5" component="div">
            Discounts:
          </Typography>
          <Stack justifyContent="space-between" spacing={2}>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Name:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.name}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Coupon:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.coupon_code}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Type:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.type}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Value:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.value}</Typography>
            </Box>
          </Stack>
        </>
      )}

      <Stack direction="row" justifyContent="space-between" mb={1} spacing={2}>
        <Stack justifyContent="left" style={{ marginTop: ' 5%' }}>
          <Box
            py={0}
            width="40%"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box>
                <Avatar
                  alt={productDetails?.user?.name}
                  src={productDetails?.user?.avatar}
                  sx={{ width: 56, height: 56 }}
                />
              </Box>
              <Box>
                <div className="one-line-ellipsis" style={{ fontSize: 20 }}>
                  {productDetails?.user?.name || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.user?.email || 'N/A'}
                </div>
              </Box>
            </Stack>
          </Box>
          <Divider variant="fullWidth" style={{ marginTop: 10, width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              flex: 1,
              marginTop: 10
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h5" component="div">
              OverAll Order Rating:
            </Typography>
            <Rating size="large" name="simple-controlled" disabled />
          </Box>
          <Divider style={{ width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h6" component="div">
              OverAll Buyer Rating:
            </Typography>
            <Rating size="large" name="simple-controlled" disabled />
          </Box>
          <Stack style={{ width: 250 }}>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Product Rating:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Delivery Rating:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Communication:
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Sending Time:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
          </Stack>

          <Divider aria-hidden="true" style={{ marginTop: 10, width: 350 }} />
          <Box
            py={0}
            style={{
              flexDirection: 'row',
              marginTop: 5,
              flex: 1
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h6" component="div">
              Vintit Rating
            </Typography>
            <Box>
              <Rating size="large" name="simple-controlled" disabled />
            </Box>
          </Box>

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              marginTop: 5,
              flex: 1,
              width: 600
            }}
          >
            <Typography
              row
              sx={{ textAlign: 'justify', marginRight: 3 }}
              variant="h5"
              component="div"
            >
              Review
            </Typography>

            <Typography row>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>
        </Stack>

        <Stack
          justifyContent="left"
          style={{ alignItems: 'flex-end', marginTop: '5%', marginLeft: -40 }}
        >
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5,
              width: 250
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Order Total:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {/* {productDetails.order_details.map((item) => {
                item?.product?.price ? item?.product?.price : 'N/A';
              })} */}
              {/* {console.log('product detail ', productDetails?.order_details[0].product.price)} */}
              {productDetails?.order_details[0].product.price
                ? productDetails?.order_details[0].product.price
                : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Buyer Protection Fee:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.buyer_protection_fee !== undefined &&
              productDetails?.over_all_sum?.buyer_protection_fee !== null
                ? productDetails?.over_all_sum?.buyer_protection_fee
                : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Delivery Fee:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.delivery_fee !== undefined &&
              productDetails?.over_all_sum?.delivery_fee !== null
                ? productDetails?.over_all_sum?.delivery_fee
                : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Discount:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.discount !== undefined &&
              productDetails?.over_all_sum?.discount !== null
                ? productDetails?.over_all_sum?.discount
                : 'N/A'}
            </Typography>
          </Box>

          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 20
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Total:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.total !== undefined &&
              productDetails?.over_all_sum?.total !== null
                ? productDetails?.over_all_sum?.total
                : 'N/A'}
            </Typography>
          </Box>
        </Stack>
      </Stack>

      <Box
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: 30
        }}
      >
        <Button color="primary" variant="contained" onClick={handleClose} size={'small'}>
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default OrderDetailModal;
